import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { useRestaurantNav } from '../../hooks/useRestaurantNav';

const Processing: React.FC = () => {
  const { navigate } = useRestaurantNav();

  // Optional: Auto-navigate after some time or polling
  useEffect(() => {
    // You could implement polling here to check workflow status
    // For now, we'll just show the processing page
  }, []);

  return (
    <div className="min-h-screen bg-[#212121] flex items-center justify-center p-6">
      <div className="max-w-2xl w-full text-center">
        {/* Logo/Brand */}
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
          className="flex items-center justify-center gap-3 mb-12"
        >
         
          <img src="assets/images/promo-logo.png" className='w-auto h-10' />
        </motion.div>

        {/* Animated Loader */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.6 }}
          className="mb-8"
        >
          <div className="relative w-32 h-32 mx-auto">
            {/* Outer spinning circle */}
            <motion.div
              animate={{ rotate: 360 }}
              transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
              className="absolute inset-0 rounded-full border-4 border-transparent border-t-[#EE4423]"
            />
            {/* Inner spinning circle */}
            <motion.div
              animate={{ rotate: -360 }}
              transition={{ duration: 1.5, repeat: Infinity, ease: "linear" }}
              className="absolute inset-4 rounded-full border-4 border-transparent border-t-[#EE4423]/50"
            />
            {/* Center dot */}
            <motion.div
              animate={{ scale: [1, 1.2, 1] }}
              transition={{ duration: 1.5, repeat: Infinity }}
              className="absolute inset-0 m-auto w-6 h-6 rounded-full bg-[#EE4423]"
            />
          </div>
        </motion.div>

        {/* Text */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.6 }}
        >
          <h2 className="text-3xl font-bold text-white mb-4">
            Generating Your Marketing Intelligence
          </h2>
          <p className="text-gray-400 text-lg mb-2">
            We're analyzing your restaurant data and creating personalized campaign ideas...
          </p>
          <motion.p
            animate={{ opacity: [0.5, 1, 0.5] }}
            transition={{ duration: 2, repeat: Infinity }}
            className="text-[#EE4423] text-sm"
          >
            This may take a few moments
          </motion.p>
        </motion.div>

      
      </div>
    </div>
  );
};

export default Processing;
